/* eslint-disable */
import Highcharts from "highcharts";

export function tooltipPipe(getUnit?: (serieName: string) => string) {
  return (options: Highcharts.Options): Highcharts.Options => ({
    ...options,
    tooltip: {
      useHTML: true,
      formatter: function () {
        const { point } = this;
        const category = point.category;
        if ((point as any).hintInfo) {
          const displayHint = (point as any).hintInfo.map((hintRow) => {
            const value = Highcharts.numberFormat(hintRow.value || 0, 2);  
            const unit = getUnit ? getUnit(hintRow.title) : null;
            const displayData = [value, unit].filter(Boolean).join(" ");    
            return `<div><b>${hintRow.title}</b>: ${displayData}</div>`
          }).join("");
          return `<div><b>${category}</b></div>${displayHint}`
        }
        const serieName = point.series.name;
        const value = Highcharts.numberFormat(point.y || 0, 2);
        const unit = getUnit ? getUnit(serieName) : null;
        const displayData = [value, unit].filter(Boolean).join(" ");
        return `<div><b>${category}</b></div>
                <div><b>${serieName}</b>: ${displayData}</div>`;
      }
    }
  });
}